<template>
    <v-select variant="outlined" density="compact" v-model="selected_ifcps" :items="ifc_parsing_setups" :rules="rules"
        :clearable="!required" :label="t('ifc_parsing_setup')">
        <!-- The setup a new project starts from, marked as in the setups table. -->
        <template #item="{ props, item }">
            <v-list-item v-bind="props">
                <template #append>
                    <v-chip v-if="item.raw.is_default" variant="flat" size="x-small" color="accent">
                        <v-icon size="x-small" start> mdi-star </v-icon>
                        {{ t("default") }}
                    </v-chip>
                </template>
            </v-list-item>
        </template>
        <template #selection="{ item }">
            <span class="text-truncate">{{ item.title }}</span>
            <v-chip v-if="item.raw.is_default" variant="flat" size="x-small" color="accent" class="ml-2">
                <v-icon size="x-small" start> mdi-star </v-icon>
                {{ t("default") }}
            </v-chip>
        </template>
    </v-select>
</template>

<script>
import { useCompanyStore } from "@/stores/company";
import { usePitStoreBasics } from "@/stores/app_common";
import { mapState } from 'pinia';
import { ifcpsFamilies } from "@/utils/ifcps_versions";
import { nameSort } from "/src/utils/basics.js";

export default {
    setup() { return { ...usePitStoreBasics(), } },
    props: {
        modelValue: { default: null },
        required: { type: Boolean, default: false },
        preselectDefault: { type: Boolean, default: false },
    },
    data: () => ({
        selected_ifcps: "",
    }),
    computed: {
        ...mapState(useCompanyStore, { "store_ifc_ps": "ifc_ps" }),
        // Every version is a setup a project can be on; a setup with more
        // than one shows its number, newest first.
        ifc_parsing_setups() {
            return ifcpsFamilies(this.store_ifc_ps)
                .sort((a, b) => nameSort(a.newest.name, b.newest.name))
                .flatMap((fam) => fam.versions.map((ips) => ({
                    title: fam.versions.length > 1 ? `${ips.name} · v${ips.version || 1}` : ips.name,
                    value: ips.uuid,
                    is_default: ips.is_default,
                })));
        },
        rules() {
            if (!this.required) return [];
            return [(v) => !!v || this.t("required")];
        },
    },
    watch: {
        selected_ifcps(v) {
            this.$emit("update:modelValue", v);
        },
        modelValue: {
            handler: function (v) {
                this.selected_ifcps = v;
            },
            immediate: true,
        },
    },
    mounted() {
        if (!this.preselectDefault || this.selected_ifcps) return;
        if (this.store_ifc_ps?.length) {
            const def = this.store_ifc_ps.find((ips) => ips.is_default);
            if (def) this.selected_ifcps = def.uuid;
        } else {
            const stop = this.$watch("store_ifc_ps", (list) => {
                if (!list?.length) return;
                stop();
                if (this.selected_ifcps) return;
                const def = list.find((ips) => ips.is_default);
                if (def) this.selected_ifcps = def.uuid;
            });
        }
    },
};
</script>